export enum HeaderModalType {
    Login = 'login',
    ForgotPw = 'forgotPw',
    ForgotPwConfirmation = 'forgotPwConfirmation'
}